import type { BaseFormComponentWrapperProps } from './types'

export function BaseFormComponentWrapper({ component, children, wrapperProps }: BaseFormComponentWrapperProps) {
	const { handleSelectComponent, isDragging, attributes, listeners, setNodeRef } = wrapperProps

	return (
		<button
			type='button'
			ref={setNodeRef}
			className={`relative w-full block ${isDragging && 'opacity-50'}`}
			onClick={handleSelectComponent}
			data-component-id={component.id}
			data-component-type={component.type}
			{...attributes}
			{...listeners}>
			{children}
		</button>
	)
}
